import React from "react";

const Skills = ({ allskills }) => {
  return (
    <section
      id="my_skills_list"
      className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8"
    >
      <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            Capability Map
          </p>
          <h2 className="font-display text-3xl font-bold text-skin-text md:text-4xl">
            Engineering, design, cloud, and delivery tools
          </h2>
        </div>
        <p className="max-w-2xl text-sm leading-7 text-skin-muted">
          Reorganized into readable category cards instead of the old rotating
          orbit so the page is more usable on phones and laptops.
        </p>
      </div>

      <div className="grid gap-5 xl:grid-cols-2">
        {allskills.map((group) => (
          <article
            key={group.type}
            className="rounded-[1.75rem] border border-white/15 bg-black/10 p-6 shadow-glass"
          >
            <div className="mb-5 flex items-center gap-4">
              <img
                src={group.image}
                alt={group.type}
                className="h-14 w-14 rounded-2xl object-cover"
              />
              <div>
                <h3 className="font-display text-2xl font-semibold text-skin-text">
                  {group.type}
                </h3>
                <p className="text-sm text-skin-muted">
                  {group.summary || "Daily-use tools and technologies"}
                </p>
              </div>
            </div>

            <div className="grid gap-3 sm:grid-cols-2">
              {group.skills.map((skill) => (
                <div
                  key={`${group.type}-${skill.title}`}
                  className="flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3"
                >
                  <img
                    src={skill.image}
                    alt={skill.title}
                    className="h-11 w-11 rounded-xl bg-white p-2 object-contain"
                  />
                  <div>
                    <h4 className="text-sm font-semibold text-skin-text">
                      {skill.title}
                    </h4>
                    <p className="text-xs text-skin-muted">
                      {skill.description || "Production experience"}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Skills;
